import * as Types from "../../../actions/actionTypes";

const initialState = {
  allNuggetsFetched: false,
};

for (let i = 1; i < 6; i++) {
  initialState["sellerSalesNugget" + i] = {
    data: {
      chart_info: {
        chart_label: "",
        data: {},
      },
    },
    loading: true,
    error: "",
  };
}

function sellerSalesNuggetReducer(state = initialState, action) {
  const newState = { ...state };
  for (let i = 1; i < 6; i++) {
    let nuggetNumber = "sellerSalesNugget" + i;

    if (
      action.type ===
      Types.sellerSalesNuggetActionTypes[
        `SELLER_SALES_NUGGET_${i}_DATA_LOADING`
      ]
    ) {
      newState[nuggetNumber] = {
        ...state[nuggetNumber],
        loading: action.payload,
      };
      return newState;
    }

    if (
      action.type ===
      Types.sellerSalesNuggetActionTypes[`SELLER_SALES_NUGGET_${i}_DATA_LOADED`]
    ) {
      newState[nuggetNumber] = {
        ...state[nuggetNumber],
        data: action.payload,
        loading: false,
        error: "",
      };
      return newState;
    }
    if (
      action.type ===
      Types.sellerSalesNuggetActionTypes[
        `SELLER_SALES_NUGGET_${i}_DATA_LOAD_ERROR`
      ]
    ) {
      newState[nuggetNumber] = {
        ...state[nuggetNumber],
        error: action.payload,
      };
      return newState;
    }
  }

  if (action.type === Types.SELLER_SALES_NUGGETS_FETCHED) {
    return {
      ...state,
      allNuggetsFetched: action.payload,
    };
  }
  if (action.type === Types.RESET_SELLER_SALES_CHART_DATA) {
    return initialState;
  }
  return state;
}

export default sellerSalesNuggetReducer;
